import script from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadio.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=fa231dfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa231dfc"]])

export default __exports__